import { http } from "@/utils/http";
export const getMessageList = (params) => {
  // 获取最新消息列表
  return http({ url: `/1/recents/`, method: "get", params: params });
};
export const getMessageDetail = (params) => {
  // 获取消息详情
  return http({ url: `/1/recents/${params.id}/`, method: "get" });
};
